import type { PropsWithChildren, ReactNode } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  type AccordionSummaryProps,
  type AccordionDetailsProps,
  styled,
  type SxProps,
} from '@mui/material';

const StyledAccordion = styled(Accordion)`
  border-radius: 8px;
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  && {
    .MuiAccordionSummary-content {
      justify-content: start;
    }
  }
`;

interface AccordionSummaryDetailsProps {
  summary: ReactNode;
  ['data-testid']?: string;
  AccordionSummaryProps?: AccordionSummaryProps & { sx: SxProps };
  AccordionDetailsProps?: AccordionDetailsProps & { sx: SxProps };
}

export function AccordionSummaryDetails(
  props: PropsWithChildren<AccordionSummaryDetailsProps>,
) {
  return (
    <StyledAccordion
      defaultExpanded={false}
      data-atlas-alignment='end'
      data-testid={props['data-testid'] || 'accordion-testid'}
    >
      {props.summary ? (
        <StyledAccordionSummary {...props.AccordionSummaryProps}>
          {props.summary}
        </StyledAccordionSummary>
      ) : null}
      <AccordionDetails {...props.AccordionDetailsProps}>
        {props.children}
      </AccordionDetails>
    </StyledAccordion>
  );
}
